import { Spinner } from '@servicetitan/anvil2';

import * as Styles from './loading-spinner.module.scss';

export const LoadingSpinner = () => {
    return (
        <div className={Styles.loadingSpinner}>
            <Spinner size="large" />
        </div>
    );
};
